import { z } from "zod";

import { PYUseQueryOptions } from "../../../api/hooks/StandardQueryArguments";

import { getNavigationConfig, navigationConfigResponseSchema } from "../../../api/services/defs/navigation";

export const navigationConfigQuery = (
	employeeId?: string,
	options?: PYUseQueryOptions<z.infer<typeof navigationConfigResponseSchema>>
) => {
	const empId = employeeId || "self";
	return {
		queryKey: ["navigation-config", empId],
		queryFn: () => getNavigationConfig(empId === "self" ? undefined : empId),
		meta: {
			errorMessage: "There was an error getting the navigation configuration.",
		},
		...options,
	};
};
